export const FIREBASE = {
  PERMISSION: {
    GRANTED: 'granted',
    DENIED: 'denied',
    DEFAULT: 'default',
  },
  DEVICE: {
    BOOKING: 'booking',
  },
}
